export const getIsCarregandoRelatorioIndicadoresGestaoDetalhado =
  (state) => state.relatoriosIndicadoresGestao.isCarregandoRelatorioIndicadoresGestaoDetalhado

export const getIsCarregandoRelatorioIndicadoresGestaoResumido =
  (state) => state.relatoriosIndicadoresGestao.isCarregandoRelatorioIndicadoresGestaoResumido

export const getIsCarregandoRelatorioIndicadoresGestaoGeral =
  (state) => state.relatoriosIndicadoresGestao.isCarregandoRelatorioIndicadoresGestaoGeral
